export default () => {
	return `

// "Hash without Sine" by Dave Hoskins (https://www.shadertoy.com/view/4djSRW)
// The classic fract(sin(x) * 43758.5453) hash depends on sin() being accurate for large arguments,
// which some GPUs (eg Intel) don't guarantee, producing blocky/angular artifacts instead of smooth noise.

float hash13(vec3 p3) {
	p3 = fract(p3 * 0.1031);
	p3 += dot(p3, p3.zyx + 31.32);
	return fract((p3.x + p3.y) * p3.z);
}

`}
